export default {
    expiryDays: 0,
    openFuturePeriods: 0,
    timelyDays: 15,
    periodType: 'Monthly',
}
